import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';
import { getFrontImage, getLocalizedValue } from '@grandvisionhq/utils';
import { Solution } from '../components/Solution.js';

var SolutionContainer = (_param)=>{
    var { solution  } = _param, props = swcHelpers.objectWithoutProperties(_param, [
        "solution"
    ]);
    const { getLabel , locale  } = useIntl();
    const { isBynderImagesEnabled  } = useFeatureToggles();
    const solutionProduct = React__default.useMemo(()=>{
        var ref;
        const imageUrl = isBynderImagesEnabled ? `${getFrontImage((ref = solution.media) === null || ref === void 0 ? void 0 : ref.images).url}?w=300&auto=format` : solution.imageUrl;
        return swcHelpers.objectSpread({}, solution, {
            imageUrl
        });
    }, [
        solution,
        isBynderImagesEnabled
    ]);
    const title = solutionProduct.name ? getLocalizedValue(solutionProduct.name, locale) : getLabel('products.contactLenses.solutions.missing');
    return /*#__PURE__*/ React__default.createElement(Solution, swcHelpers.extends({}, props, {
        solution: solutionProduct,
        title: title
    }));
};

export { SolutionContainer };
//# sourceMappingURL=SolutionContainer.js.map
